import CheckboxSelect from 'views/components/Validation/CreateValidation/CheckboxSelect/CheckboxSelect';

export default CheckboxSelect;
